import { useAction } from 'convex/react'; // CROSS_IMPORT_JUSTIFIED: convex/react is the official client-side React bindings package, not a server module
import { api } from '@convex/_generated/api';
import type { Id } from '@convex/_generated/dataModel';

export function useTriggerWebsiteLeadAi(): (leadId: Id<'leads'>) => Promise<void> {
  const trigger = useAction(api.aiReply.websiteLead.triggerManual);
  return async leadId => {
    await trigger({ leadId });
  };
}
